export default __webpack_public_path__ + "static/media/dashboard_blue.193bb4b2.svg";